<template>
  <div
    id="app-wrapper"
    :class="'route-'+routeName"
  >
    <transition
      v-if="!featureFlagsLoadingState"
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

const {mapState} = createNamespacedHelpers('app');
const {
  mapState: systemInfoMapState,
  mapActions: systemInfoMapActions,
} = createNamespacedHelpers('systemInfo');

export default {
  name: 'App',
  data: () => {
    return {
      menuOpened: true,
    };
  },
  computed: {
    ...systemInfoMapState({
      featureFlags: state => state.systemSettings.featureFlags,
      featureFlagsLoadingState: state => state.systemSettings.featureFlagsLoadingState,
    }),
    ...mapState([
      'menuCollapsed',
      'menuHidden',
      'menuPin',
    ]),
    routeName() {
      return this.$route.name
        ?  this.$route.name.replace('.', '-')
        : '';
    },
  },
  methods:{
    ...systemInfoMapActions(['getFeatureFlagsData']),
  },
  async beforeMount(){
    await this.getFeatureFlagsData();
    localStorage.setItem('featureFlags', JSON.stringify(this.featureFlags));
  },
};
</script>

<style lang="scss">
  @import "./core/scss/variables";
  @import "~vue-select/src/scss/vue-select.scss";

  html,
  body,
  #app-wrapper {
    height: 100vh;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  #app {
    &.menu-collapsed {
      &.menu-fixed {
        padding-left: $menu-width-collapsed;
      }

      .show-hide-menu {
        visibility: hidden;
      }

      #main {
        margin-left: $menu-width-collapsed;
      }

      .menu {
        overflow: visible;
        width: $menu-width-collapsed;
        z-index: 9999;
        background: blue;

        .menu-heading {
          .menu-header-buttons-wrapper {
            .btn-menu-header-collapse {
              display: inline-block;
            }

            .menu-header-buttons {
              display: inline-block;
              position: absolute;
              width: 0;
              top: 0;
              height: 100%;
              left: 100%;
              padding: inherit;
              @include transition(all $transition-duration);
              @include box-shadow(2px 2px 5px rgba(0, 0, 0, 0.1));
            }

            &:hover {
              .btn-menu-header-collapse {
                float: left;
              }

              .menu-header-buttons {
                min-width: $menu-width;
                background-color: $menu-bg;
              }
            }
          }
        }

        nav {
          div {
            ul {
              background: red;
              > li {
                > a {
                  text-align: center;

                  .inner-text, .menu-item-toggle-icon {
                    display: none;
                  }

                  .badge-wrapper {
                    line-height: 1;
                    top: 2px;
                    right: 2px;
                  }
                }

                > ul {
                  display: none !important;
                }

                &.opened {
                  > a {
                    border-bottom: none;
                  }
                }

                &:hover {
                  > a {
                    .inner-text {
                      display: block;
                      position: absolute;
                      top: 0;
                      text-align: left;
                      border: 1px solid $menu-border-color;
                      left: $menu-width-collapsed - 5px;
                      width: $menu-width;
                      background-color: $nav-menu-item-active-bg;
                      padding: $nav-menu-item-padding-vertical $nav-menu-item-padding-horizontal;
                      z-index: 4;
                    }
                  }

                  > ul {
                    display: block !important;
                    position: absolute;
                    top: 100%;
                    border: 1px solid $menu-border-color;
                    border-top-color: transparent;
                    margin-top: -1px;
                    left: $menu-width-collapsed - 5px;
                    width: $menu-width;
                    z-index: 3;
                  }
                }
              }
            }
          }
        }

        .menu-collapse-line {
          .menu-toggle-btn {
            > * {
              @include rotate(180deg);
            }
          }
        }
      }
    }

    &.menu-hidden,
    &.menu-hidden-partial {
      .menu {
        .menu-collapse-line {
          display: none;
        }
      }
    }

    &.menu-hidden {
      #main {
        margin-left: 0;
      }
    }

    &.header-fixed {
      padding-top: $navbar-height;
    }

    &.menu-fixed {
      padding-left: $menu-width;
      transition: padding-left 0.3s;
    }

    @include media-breakpoint-down(sm) {
      &.menu-fixed {
        padding-left: 0;
      }
    }

    &.menu-fixed.menu-hidden {
      padding-left: 0;
    }
  }

  .d3-context-menu {
    position: absolute;
    display: none;
    background-color: #f2f2f2;
    border-radius: 4px;

    font-family: Arial, sans-serif;
    font-size: 14px;
    min-width: 150px;
    border: 1px solid #d4d4d4;

    z-index: 1200;
  }

  .d3-context-menu ul {
    list-style-type: none;
    margin: 4px 0px;
    padding: 0px;
    cursor: default;
  }

  .d3-context-menu ul li {
    padding: 4px 16px;
  }

  .d3-context-menu ul li:hover {
    background-color: #4677f8;
    color: #fefefe;
  }

  .complex-table, .complex-table-view {
    th {
      .dropdown.b-dropdown.header-actions.btn-group {
        .btn-link {
          color: white !important;
        }
      }
    }

  }

</style>
